// extracted by mini-css-extract-plugin
module.exports = {"invalidLabel":"styles_invalidLabel__2vz64","inputContainer":"styles_inputContainer__3wcGW","submit":"styles_submit__2seuR","isLoading":"styles_isLoading__2iPM_"};